<template>
  <van-action-sheet
        v-model="open"
        :title="title"
        :description="description"
        :round="round"
        :actions="list"
        :cancel-text="cancelText"
        :close-on-click-action="closeOnClickAction"
        get-container="body"
        @cancel="onCancel"
        @select="onSelect"
    />
</template>

<script>
import { ActionSheet } from "vant";
export default {
    components:{
        [ActionSheet.name]: ActionSheet
    },
    data() {
        return {
            open: false,
            title: "",
            description: "",
            round: false,
            list: [],
            cancelText: "",
            closeOnClickAction: true,
            promiseResolve: null,
            promiseReject: null,
            initialData: {}
        }
    },
    created(){
        this.initialData = this.deepClone(this.$data);
    },
    methods: {
        init(options){
            return new Promise((resolve, reject) => {
                this.reset();
                this.promiseResolve = resolve;
                this.promiseReject = reject;
                if(options) {
                    Object.keys(options).map(key => {
                        if(!this.$data.hasOwnProperty(key)) return;
                        this[key] = ["[object Object]","[object Array]"].includes(Object.prototype.toString.call(options[key])) 
                        ? this.deepClone(options[key]) : options[key];
                    })
                }
                this.open = true;
            })
        },
        onSelect(value){
            this.promiseResolve(value);
        },
        onCancel(){
            this.promiseReject();
        },
        reset(){
            Object.keys(this.initialData).map(key => {
                if(key === "initialData") return false;
                this[key] = ["[object Object]","[object Array]"].includes(Object.prototype.toString.call(this.initialData[key])) 
                ? this.deepClone(this.initialData[key]) : this.initialData[key];
            })
        },
    }
}
</script>

<style>

</style>